import { emit, getOwner } from './my_utils.js'
import NetworkUtils from './network_utils.js'
import Settings from './settings.js'
import store from '../../store/index.js'
import { shouldAskRejectionReason } from './rejection_reasons.js'

class OffersHelper {
  defaultWhatsAppMessage = `היי {{?applicant}}, 
האם חזרו אליך מ {{?company}} בנוגע למשרה ששלחנו?
{{?admin}}, שירות השמה {{?env}}`

  ghanaFlagMessage = `היי {{?applicant}},
זו {{?admin}} משירות ההשמה {{?env}}.
הגשנו מועמדות ל{{?company}}.
האם יצרו איתך קשר?
אשמח לסייע ולקדם את התהליך עבורך (:`

suitupGhanaFlagMessage = `היי {{?applicant}},
זו {{?admin}} מ-Suitup השמת עורכי דין.
הגשנו מועמדות ל{{?company}}.
האם יצרו איתך קשר?
אשמח לסייע ולקדם את התהליך עבורך (:`

  positionOfferMessage = `היי {{?applicant}}, זו {{?admin}} משירות ההשמה - {{?env}} .
רציתי לספר לך שנפתחה משרה חדשה של {{?position}} ב-{{?company}}. האם רלוונטי עבורך?
  `

  piolaVettingMessage = `היי {{?applicant}},
 
  בהמשך לשיחתנו אני מצרפת עבורך קישורים לאתר Piola ,שם עמוד המשרות שלנו מתעדכן כל הזמן! 💪🏻
   
  לצפייה במשרות שלנו 💼 – 
  https://piola.co.il/positions
   
  ממליצים לעקוב אחרינו 👈🏻
   
  לעמוד הפייסבוק: https://www.facebook.com/PiolaHR/

  לעמוד הלינקדאין: https://www.linkedin.com/company/piolahr/
   
  המשך יום נעים , {{?admin}} Piola :)
  `

  suitupVettingMessage = `היי {{?applicant}},
  אני מצרפת עבורך קישורים לאתר suitup, שם עמוד המשרות שלנו מתעדכן כל הזמן! 💼🧑🏼‍🎓👩‍🎓
   
  אפליקציית Suitup לצפייה במשרות מותאמות ולפרופיל האישי  – https://suitup.website
   
  לצפייה במשרות שלנו באתר – https://suitup.co.il/positions
   
  שימו 🖤 - מומלץ לעקוב אחרינו:
  בפייסבוק👍  https://www.facebook.com/suitup.co.il
  בלינקדאין👍  https://www.linkedin.com/company/suitup-io
  ובאינסטגרם👍  https://www.instagram.com/suitup.co.il
   
  המשך יום נעים, {{?admin}} Suitup :)
  `

  rebaseVettingMessage = `היי {{?applicant}}, 
  בהמשך לשיחתנו מצרפת עבורך קישורים לאתר Rebase, שם עמוד המשרות שלנו מתעדכן כל הזמן! 🏗️👷
   
  לצפייה במשרות שלנו – https://rebase.co.il/positions
   
  מומלץ לעקוב אחרינו גם בפייסבוק⚡ : https://www.facebook.com/rebase.co.il/
   
  המשך יום נעים, {{?admin}} Rebase :)
  `

  piolaVestingMessage = `היי {{?applicant}}, שמחנו מאוד ללוות אותך בתהליך מציאת העבודה🤩📚💪
  רצינו לאחל המון בהצלחה בתפקיד החדש, התאקלמות מהירה,
  וכמובן להזכיר שאנחנו כאן עבורך לטווח הארוך! 🌸

  💜יש לך חברים שמחפשים עבודה בתחום? אנחנו נשמח לסייע גם להם (במסגרת מבצע חבר מביא חבר שלנו 🎁)
  
  💜נהנית מהשירות שלנו? נשמח מאוד להמלצה! (אפשר לכתוב לנו גם כאן☺️🙏)`

  suitupVestingMessage = `היי {{?applicant}}, שמחנו מאוד ללוות אותך בתהליך מציאת העבודה🤩💼💪
  רצינו לאחל המון בהצלחה בתפקיד החדש, התאקלמות מהירה,  
  וכמובן להזכיר שאנחנו כאן עבורך לטווח הארוך! 🌸

  ⭐יש לך חברים שמחפשים עבודה בתחום? אנחנו נשמח לסייע גם להם (במסגרת מבצע חבר מביא חבר שלנו 🎁)
  
  ⭐נהנית מהשירות שלנו? נשמח מאוד להמלצה! (אפשר לכתוב לנו גם כאן☺️🙏)`

  rebaseVestingMessage = `היי {{?applicant}}, שמחנו מאוד ללוות אותך בתהליך מציאת העבודה🤩🏗️💪
  רצינו לאחל המון בהצלחה בתפקיד החדש, התאקלמות מהירה,  
  וכמובן להזכיר שאנחנו כאן עבורך לטווח הארוך! 🌸

  ⚡יש לך חברים שמחפשים עבודה בתחום? אנחנו נשמח לסייע גם להם (במסגרת מבצע חבר מביא חבר שלנו 🎁)
  
  ⚡נהנית מהשירות שלנו? נשמח מאוד להמלצה! (אפשר לכתוב לנו גם כאן☺️🙏)`

  bullrunVestingMessage = `היי {{?applicant}}, שמחנו מאוד ללוות אותך בתהליך מציאת העבודה🤩🖥️💪
  רצינו לאחל המון בהצלחה בתפקיד החדש, התאקלמות מהירה,
  וכמובן להזכיר שאנחנו כאן עבורך לטווח הארוך! 🌸

  ☄️יש לך חברים שמחפשים עבודה בתחום? אנחנו נשמח לסייע גם להם (במסגרת מבצע חבר מביא חבר שלנו 🎁)
  
  ☄️נהנית מהשירות שלנו? נשמח מאוד להמלצה! (אפשר לכתוב לנו גם כאן☺️🙏)`

  greenCompanyMessage = `היי :) מצ"ב ריכוז מועמדים שהעברנו למשרת {{?position}}:
  {{?applicants}}
  האם יש עדכון לגבי אחד מהם? תרצו לחדד לנו לגבי מועמדים נוספים?`

  rejectCompanyMessage = `*מועמדים ששלחנו למשרת {{?position}} ונשללו על ידכם:*
  {{?applicants}}
  האם תרצו שנקפיץ מישהו מהם לבחינה נוספת?`

  constructor () {
    this.network_utils = new NetworkUtils()
    this.settings = new Settings()
  }

  getStatus (status) {
    if (typeof status == 'string') {
      return status
    }
    return status.name
  }

  // Feed X-reject. The structured reason (category + short text) is SAMPLED:
  // only ~1 in 3 rejects opens the blocking modal; the rest reject immediately
  // with no reason (rebase_server treats the reason as optional on this PUT).
  // When the modal does open, cancelling it aborts the reject entirely (no PUT,
  // no toast).
  //
  // `on_done` (optional) is invoked after a successful reject so callers that
  // refresh UI after a reject can still do so. Existing callers pass nothing and
  // keep working unchanged.
  rejectOffer (offer, show_toast = true, on_done) {
    if (!shouldAskRejectionReason()) {
      this.changeOfferStatus({
        offer,
        new_data: { status: 'awaiting_admin_later' }
      }).then(() => {
        if (show_toast) {
          emit('show_toast', { text: 'ההצעה נפסלה' })
        }
        if (typeof on_done === 'function') {
          on_done()
        }
      }).catch(() => {
        emit('show_toast', { text: 'שגיאה בפסילת ההצעה — נסי שוב', type: 'error' })
      })
      return
    }
    store.commit('modals/create', {
      designator: 'offer-reject-reason-modal-' + offer.id,
      component_name: 'OfferRejectReasonModal',
      data: {
        offer,
        onConfirm: (category, text) => {
          this.changeOfferStatus({
            offer,
            new_data: {
              status: 'awaiting_admin_later',
              rejection_reason_category: category,
              rejection_reason_text: text
            }
          }).then(() => {
            if (show_toast) {
              emit('show_toast', { text: 'ההצעה נפסלה והסיבה נשמרה' })
            }
            if (typeof on_done === 'function') {
              on_done()
            }
          }).catch(() => {
            emit('show_toast', { text: 'שגיאה בפסילת ההצעה — נסי שוב', type: 'error' })
          })
        }
      },
      modal_title: 'סיבת פסילה',
      modal_width: 560,
      is_center_modal: true
    })
  }

  changeOfferStatus (params) {
    let old_status = this.getStatus(params.offer.status)
    let new_status = this.getStatus(params.new_data.status)
    let old_message = params.offer.message
    let new_message = params.new_data.message
    if (new_message != undefined && new_message.length >= 500) {
      params.new_data.message = params.new_data.message.substring(0, 500)
    }
    return this.network_utils.caller.request(
      'put',
      '/offers/' + params.offer.id,
      'admin_headers',
      params.new_data
    )
      .then(() => {
        if (old_status != new_status) {
          this.sendStatusChangedStat({
            offer_id: params.offer.id,
            old_status: old_status,
            new_status: new_status
          })
        }
        if (new_message != undefined && old_message != new_message) {
          this.sendMessageChangedStat({
            offer_id: params.offer.id,
            old_message: old_message,
            new_message: new_message
          })
        }
      })
  }

  sendMessageChangedStat (params) {
    this.network_utils.postStat({
      designator: 'next_contact_message_changed',
      resource_type: 'Offer',
      resource_id: params.offer_id,
      owner: getOwner().name,
      title: 'Message changed',
      content: 'Message changed to: <b>' + params.new_message + '</b>',
      priority: 6
    })
  }

  sendStatusChangedStat (params) {
    this.network_utils.postStat({
      designator: 'offer_to_' + params.new_status,
      resource_type: 'Offer',
      resource_id: params.offer_id,
      owner: getOwner().name,
      title: 'Status changed',
      content: params.old_status + ' ---> ' + '<b>' + params.new_status + '</b>',
      priority: 6
    })
  }

  getWhatsAppLinkPayload (offer, template = 'defaultWhatsAppMessage') {
    let temp = template
    if (this.settings.get({ path: 'operation_name' }) === 'Suitup' && temp === 'ghanaFlagMessage') {
      temp = 'suitupGhanaFlagMessage'
    }
    const text = this.createFromTemplate(this[temp], {
      applicant: offer.applicant.first_name,
      company: offer.position.company.is_discrete ? offer.position.company.public_name : offer.position.company.name,
      position: offer.position.title,
      admin: getOwner().first_name || getOwner().name,
      env: this.settings.get({ path: 'operation_name' })
    })
    return { phoneNumber: offer.applicant.phone_number, message: text }
  }

  outSourceTemplate (data, template) {
    return this.createFromTemplate(this[template], data)
  }

  createFromTemplate (template, params) {
    if (!template.length) {
      return ''
    }
    return template.replace(/{{\?[a-zA-Z]*}}/g, (key) => {
      return params[key.slice(3, -2)]
    })
  }
}

export default OffersHelper
